export default __webpack_public_path__ + "5eQJ5za-thx.svg";